module.exports = __webpack_public_path__ + "static/media/aepe_full.ae077d80.jpg";